<script>
  import { listPosts } from "../api.js";
  import { notification } from "/shared/utils.js";
  import { updates } from "../stores.js";
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import BusinessUpdate from "./BusinessUpdate.svelte";
  import BusinessUpdatesList from "./BusinessUpdatesList.svelte";
  import LoadAllUpdatesButton from "./LoadAllUpdatesButton.svelte";

  export let businessCode;
  export let publicPostsOnly = false; // show all posts

  let isOpen = false;
  const toggle = () => {
    isOpen = !isOpen;
    // hide booking footer at bottom of page
    const bookingFooter = document.querySelector(".booking-footer");
    if (isOpen && bookingFooter) {
      bookingFooter.style.visibility = "hidden";
    } else if (!isOpen && bookingFooter) {
      bookingFooter.style.visibility = "visible";
    }
  };

  /*
   * call the API to get a list of BusinessUpdates
   */
  listPosts(businessCode, publicPostsOnly)
    .then((data) => {
      $updates = data.results;
    })
    .catch((error) => {
      notification.reportError(error);
    });
</script>

<!-- Only display card if there is at least 1 update -->
{#if $updates.length}
  <div class="card border-0 shadow mb-5">
    <div class="card-body pt-4">
      <p class="subtitle text-primary">Our News</p>
      <!-- show up to 2 updates -->
      {#each $updates.slice(0, 2) as update, updateIndex}
        <BusinessUpdate {update} {updateIndex} on:click={toggle} />
      {/each}
      <div class="text-center btn btn-outline-muted btn-block mt-4" on:click={toggle}>
        See all updates
      </div>
    </div>
  </div>
{/if}

<!-- MODAL -->
{#if $updates.length}
  <Modal {isOpen} {toggle}>
    <ModalHeader {toggle}>Our News</ModalHeader>
    <ModalBody class="px-5">
      <BusinessUpdatesList />
    </ModalBody>
  </Modal>
{/if}
<!-- /MODAL -->
